import React from "react"

function Cardbutton() {
    return <div className="card-buttons">
        <button className="card-button">Edit</button>
        <button className="card-button">Delete</button>
    </div>
}

export default Cardbutton;